import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import { v4 as uuidv4 } from 'uuid'

Vue.use(Vuex)

//import { DEFAULT_LANGUAGE } from '../components/translation/Translation';

export default new Vuex.Store({
  state: {
    loadingApplication: true,
    preProduction: false,
    //language: DEFAULT_LANGUAGE,
    responses: {},
    variables: {},
    computedVariables: [],
    collectionFormLanguages: [],
    sessionId: uuidv4(),
    researchStudyGroupId: null,
    collectionFormId: null,
    currPage: 0,
    currentModalName: null,
    pageList: [],
    globalLabels: [],
    elementDictionary: {}, // Map of Element ID -> Element
    countryConfigurations: [],
    validationErrors: [], // Array of Element SF IDs that were found to have validation errors
    errorLoadingCollectionForm: false,
    errorStatus: 0,
    collectionFormStatus: null,
    leadStatus: 'In Progress',
    selectedSiteRecord: {},
    isRtlLanguage: false,
    lastResponseTime: null // Time that the user last answered a question
  },
  getters,
  mutations,
  actions
})
